import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const TRACKING_PARAM_PREFIXES = ['utm_'];
const TRACKING_PARAMS = new Set([
  'gclid',
  'gbraid',
  'wbraid',
  'fbclid',
  'msclkid',
  'mc_cid',
  'mc_eid',
  '_hsenc',
  '_hsmi',
]);

const TrackingParamCleaner = () => {
  const location = useLocation();

  useEffect(() => {
    if (!location.search) return;

    const params = new URLSearchParams(location.search);
    let changed = false;

    Array.from(params.keys()).forEach((key) => {
      const isTrackingParam =
        TRACKING_PARAMS.has(key) ||
        TRACKING_PARAM_PREFIXES.some((prefix) => key.startsWith(prefix));

      if (isTrackingParam) {
        params.delete(key);
        changed = true;
      }
    });

    if (!changed) return;

    const nextSearch = params.toString();
    const nextUrl = `${location.pathname}${nextSearch ? `?${nextSearch}` : ''}${location.hash}`;

    window.history.replaceState(window.history.state, '', nextUrl);
  }, [location.hash, location.pathname, location.search]);

  return null;
};

export default TrackingParamCleaner;
